import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { toast } from "sonner";

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');
      console.log('SW registered:', registration);
      
      // Check for updates every 5 minutes
      setInterval(async () => {
        try {
          await registration.update();
        } catch (error) {
          console.error('SW update failed:', error);
        }
      }, 5 * 60 * 1000);

      // When a new service worker is waiting to be activated
      registration.addEventListener('waiting', (event) => {
        toast.message("تحديث جديد متاح", {
          action: {
            label: "تحديث الآن",
            onClick: () => {
              if (registration.waiting) {
                registration.waiting.postMessage('skipWaiting');
                window.location.reload();
              }
            },
          },
        });
      });
    } catch (error) {
      console.error('SW registration failed:', error);
    }
  });

  // Handle service worker updates
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);